import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const PutawayHubPageRBAC = {
  pageID: '92bb3408668bbbbff28bff573c4b408f',
  elementID: {
    ViewPage: 'dcaa06d643e9e740a87e368495a822bd',
  },
} as const

export const useRBACPutawayHubPage = createUseRBAC(PutawayHubPageRBAC.elementID)

export type UseRBACPutawayHubPageType = ReturnType<typeof useRBACPutawayHubPage>
